import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3b8403bc")

_pushScopeId("data-v-3b8403bc")
const _hoisted_1 = { class: "row justify-center q-mt-md" }
const _hoisted_2 = { class: "row justify-center q-mt-md" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_q_td = _resolveComponent("q-td")
  const _component_q_tr = _resolveComponent("q-tr")
  const _component_q_table = _resolveComponent("q-table")
  const _component_q_pagination = _resolveComponent("q-pagination")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_q_table, {
      rows: _ctx.asignaciones,
      columns: _ctx.columns,
      "row-key": "descripcion",
      pagination: _ctx.localPagination,
      "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => (_ctx.localPagination = $event)),
      loading: _ctx.loading,
      "hide-pagination": "",
      "no-data-label": "No se encontraron asignaciones para la búsqueda realizada"
    }, {
      body: _withId((rows) => [
        _createVNode(_component_q_tr, null, {
          default: _withId(() => [
            _createVNode(_component_q_td, { key: "numeroExp" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(rows.row.numeroExp), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_q_td, { key: "anioExp" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(rows.row.anioExp), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_q_td, { key: "reparticion" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(rows.row.reparticion), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_q_td, { key: "nombreAuxiliar" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(rows.row.nombreAuxiliar), 1)
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_q_td, { key: "creacionFecha" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(rows.row.creacionFecha), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["rows", "columns", "pagination", "loading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_q_pagination, {
        modelValue: _ctx.localPagination.page,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.localPagination.page = $event)),
        max: _ctx.pagination.totalPages,
        "max-pages": 5,
        "direction-links": "",
        "boundary-links": "",
        "icon-first": "skip_previous",
        "icon-last": "skip_next",
        "icon-prev": "fast_rewind",
        "icon-next": "fast_forward"
      }, null, 8, ["modelValue", "max"])
    ]),
    _createVNode("div", _hoisted_2, "Elementos totales: " + _toDisplayString(_ctx.pagination.rowsNumber), 1)
  ]))
})